/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionSubServiceUpdate } from '../../models/subscription-sub-service-update';

export interface UpdateSubscriptionSubService$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  serviceUid: string;
      body: SubscriptionSubServiceUpdate
}

export function updateSubscriptionSubService(http: HttpClient, rootUrl: string, params: UpdateSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSubscriptionSubService.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('serviceUid', params.serviceUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSubscriptionSubService.PATH = '/subscriptions/{uid}/sub-service/{serviceUid}';
